import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-loader-1',
  standalone: true,
  imports: [
    LottieComponent,
    TranslateModule
  ],
  templateUrl: './loader-1.component.html',
  styleUrls: ['./loader-1.component.scss'],
})
export class Loader1Component {
  public options: AnimationOptions = {
    path: '/assets/animations/loader-1.json',
  }
}
